import { render, staticRenderFns } from "./BaseEmptyList.vue?vue&type=template&id=49a910ec&"
import script from "./BaseEmptyList.vue?vue&type=script&lang=ts&"
export * from "./BaseEmptyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports